import type { RxJsonSchema } from 'rxdb';
import type { Urgency } from './urgency.types';

export const urgencySchema: RxJsonSchema<Urgency> = {
  type: 'object',
  version: 0,
  description: 'describes Urgency',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    name: { type: ['string', 'null'] },
    discipline: { type: ['number', 'null'] },
    sort: { type: ['number', 'null'] },
    isActive: { type: ['boolean', 'null'] },
    dateModified: { type: ['string', 'null'] },
  },
};
